import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton, // Import IconButton for the close button
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import globalStyle from "../../globalStyle";
import appcolors from "../../constants/Colors";
import { Visibility, VisibilityOff, Close } from "@mui/icons-material"; // Import the Close icon
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    // padding: "0 2rem",
    // [theme.breakpoints.down("sm")]: {
    //   padding: "0 8px",
    // },
  },
  "& .MuiDialogActions-root": {
    padding: "25px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "25px  8px",
    },
  },
}));
let paramsData = {};

const ProfileSaveDialog = forwardRef(({ handleSaveProfile }, ref) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
      setPassword("");
      setPasswordError(false);
      setShowPassword(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setShowPassword(false);
    setPassword("");
    setPasswordError(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      {/* Close button in the top-right corner */}
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>

      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {t("confirmation")}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label labelText={t("password")} required />
            <TextInput
              required={true}
              styleProps={globalStyle.textField}
              type={showPassword ? "text" : "password"}
              inputError={passwordError}
              helperText={passwordError && t("passwordRequired")}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(false);
              }}
              InputEndIcon={
                showPassword ? (
                  <Visibility
                    onClick={() => setShowPassword(false)}
                    style={{ cursor: "pointer", color: appcolors.black }}
                  />
                ) : (
                  <VisibilityOff
                    onClick={() => setShowPassword(true)}
                    style={{ cursor: "pointer", color: appcolors.black }}
                  />
                )
              }
            />
          </Grid>
        </Grid>
        <Typography
          mt={2}
          variant="body2"
          textAlign={"center"}
          color={"primary.main"}
        >
          {t("changeAllDetailsPrompt")} ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          styleProps={{ height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"yes"}
          styleProps={{ height: 40 }}
          handleClickBtn={() => {
            if (password) {
              handleSaveProfile(password);
            } else {
              setPasswordError(true);
            }
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default ProfileSaveDialog;
